import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { SpouseContactDetailsFormGroup } from '../../../../models/shared/forms/spouse-contact-details-form-group';
import { TypeService } from '../../../../services/type/type-service';
import { map, startWith } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { MemberUser } from '../../../../models/users/dto/member-user';
import { MemberRecord } from '../../../../models/users/dto/member-record';
import { PortalService } from '../../../../services/portal/portal.service';
import { PortalTypeIdEnum } from '../../../../models/enum/shared/portal-type-id.enum';

@Component({
  selector: 'app-spouse-contact-details-form',
  templateUrl: './spouse-contact-details-form.component.html',
  styleUrls: [
    './spouse-contact-details-form.component.scss',
    '../spouse-personal-information-form/spouse-personal-information-form.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class SpouseContactDetailsFormComponent implements OnChanges, OnDestroy {
  @Input() formGroup!: SpouseContactDetailsFormGroup;
  @Input() formSubmitted: boolean = false;
  @Input() originalMember!: MemberUser | MemberRecord;

  private typeService = inject(TypeService);
  private portalService = inject(PortalService);

  private addressSub: Subscription | null = null;

  public countryCodes$ = this.typeService.countryCodes$;

  public useAddressCheckboxLabel$ = this.portalService.portalTypeId$.pipe(
    map(portalTypeId => {
      return portalTypeId === PortalTypeIdEnum.Member ? $localize`Use my address` : $localize`Use member’s address`;
    })
  );

  public toggleUseMemberAddress(useMemberAddress: boolean): void {
    if (useMemberAddress) {
      this.useMembersAddress();
    } else {
      this.formGroup.controls.address.enable({ emitEvent: false });
    }
    this.formGroup.updateValueAndValidity();
  }

  private useMembersAddress(): void {
    const address = this.originalMember?.address;
    if (!address) return;
    this.formGroup.controls.address.enable({ emitEvent: false });
    this.formGroup.controls.address.patchValue({
      countryId: address.countryId,
      addressLine1: address.addressLine1,
      addressLine2: address.addressLine2,
      addressLine3: address.addressLine3,
      city: address.city,
      stateId: address.stateId,
      postalCode: address.postalCode
    });
    this.formGroup.controls.address.disable({ emitEvent: false });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.formGroup) {
      this.addressSub?.unsubscribe();
      this.addressSub = this.formGroup.controls.useMemberAddress.valueChanges
        .pipe(startWith(this.formGroup.controls.useMemberAddress.value))
        .subscribe(useMemberAddress => this.toggleUseMemberAddress(useMemberAddress ?? false));
    }
  }

  public ngOnDestroy(): void {
    this.addressSub?.unsubscribe();
  }
}
